import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { NavService } from 'src/app/core/services/nav.service';
import {NGXLogger} from "ngx-logger";
import {NavItem} from "../models/nav-item";

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.css'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})

export class MenuListItemComponent implements OnInit {
  private navItems: NavItem[] = [
    {
      displayName: 'Home',
      route: '/',
      selected: false,
    }];
  expanded: boolean = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem = this.navItems[0];
  @Input() depth: number | undefined = undefined;

  /**
   * Constructor
   * @param navService Navigation service instance.
   * @param router Router instance.
   * @param logger Logger instance.
   */
  constructor(public navService: NavService,
              public router: Router,
              private logger: NGXLogger) {
    if (this.depth === undefined) {
      this.logger.debug("depth:" + this.depth )
      this.depth = 0;
    }
    else
    {
      this.logger.debug("item:" + this.item.displayName + " depth:" + this.depth);
    }
  }

  /**
   * Init
   */
  ngOnInit() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item?.route && url) {
        this.logger.debug(`Checking '/${this.item.route}' against '${url}'`);
        this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
        this.logger.debug(`${this.item.route} is expanded: ${this.expanded} depth: ${this.depth}`);
      }
    });
  }

  /**
   * Called when item is selected.
   * @param item The Navitem selected.
   */
  onItemSelected(item: NavItem) {
    item.selected = true;
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }
}
